import { debounce } from 'lodash';

class Currencies {
  constructor ({ mainCurrencies, otherCurrencies, selectedOption, hotelCurrency }) {
    this.mainCurrencies = mainCurrencies || [];
    this.otherCurrencies = otherCurrencies || [];
    this.mainCurrenciesCodes = this.mainCurrencies.map(currency => currency.code);
    this.selectedOption = selectedOption || null;
    this.hotelCurrency = hotelCurrency || null;
  }

  static empty = () => new Currencies({})

  static computeCurrencies (currencies, selectedCurrencyCode, hotelCurrencyCode) {
    const mainCurrencyCodes = [hotelCurrencyCode, 'EUR', 'USD', 'GBP'];
    const mainCurrencies = currencies
      .filter(currency => mainCurrencyCodes.includes(currency.code))
      .map(currency => {
        if (currency.code === hotelCurrencyCode) return { currency, order: 1 }
        switch (currency.code) {
          case 'USD': return { currency, order: 2 }
          case 'EUR': return { currency, order: 3 }
          case 'GBP': return { currency, order: 4 }
        }
      })
      .sort((a, b) => a.order - b.order)
      .map(obj => obj.currency);

    const otherCurrencies = currencies
      .filter(currency => !mainCurrencyCodes.includes(currency.code) && (currency.code !== 'LBP' && currency.code !== 'TRL'))
      .sort((a, b) => (a.code > b.code) ? 1 : ((b.code > a.code) ? -1 : 0));

    const hotelCurrency = currencies.find(currency => currency.code === hotelCurrencyCode);
    const selectedOption = currencies.find(currency => currency.code === selectedCurrencyCode) || hotelCurrency;

    return new Currencies({ mainCurrencies, otherCurrencies, selectedOption, hotelCurrency })
  }

  filterByText (text) {
    const cleanText = text.trim().toLowerCase();
    const currencyMatchWithText = (currency) => (currency.code.toLowerCase().includes(cleanText) || currency.name.toLowerCase().includes(cleanText));
    const isMainCurrencyCode = (currencyCode) => this.mainCurrenciesCodes.includes(currencyCode);

    return {
      mainCurrencies: this.mainCurrencies.filter(currency => currencyMatchWithText(currency) && isMainCurrencyCode(currency.code)),
      otherCurrencies: this.otherCurrencies.filter(currency => currencyMatchWithText(currency) && !isMainCurrencyCode(currency.code))
    }
  }

  clone = () => new Currencies({ ...this })
}

//

var script$5 = {
  name: 'CurrencyOptions',
  props: {
    currencies: {
      type: Currencies
    },
    selectedCurrencyCode: Object,
    labelMainCurrencies: String,
    labelAllCurrencies: String,
    labelHotelCurrency: String,
    labelPlaceholder: String
  },
  data: () => ({
    searchText: '',
    filteredCurrencies: [],
    mainCurrencies: [],
    isHovering: false
  }),
  created () {
    this.mainCurrencies = this.currencies.mainCurrencies;
    this.filteredCurrencies = this.currencies.otherCurrencies;
  },
  methods: {
    handleSelect (selectedOption) {
      this.$emit('onSelectOption', selectedOption);
    },
    filterCurrencies (text) {
      this.searchText = text;
      const { mainCurrencies, otherCurrencies } = this.currencies.filterByText(text);
      this.mainCurrencies = mainCurrencies;
      this.filteredCurrencies = otherCurrencies;
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "options" }, [
    _c("div", { staticClass: "options__input-container" }, [
      _c("input", {
        ref: "search",
        staticClass: "options__input",
        attrs: {
          autocomplete: "off",
          role: "menuitem",
          type: "search",
          placeholder: _vm.labelPlaceholder
        },
        domProps: { value: _vm.searchText },
        on: {
          input: function($event) {
            return _vm.filterCurrencies($event.target.value)
          },
          focus: function($event) {
            return $event.stopPropagation()
          },
          click: function($event) {
            return $event.stopPropagation()
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "options__list", attrs: { role: "menu" } },
      [
        _vm.mainCurrencies.length > 1
          ? _c("li", { staticClass: "options__title" }, [
              _vm._v(_vm._s(_vm.labelMainCurrencies))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.mainCurrencies, function(currency) {
          return _c(
            "li",
            {
              key: currency.code,
              staticClass: "options__element hover",
              class:
                _vm.selectedCurrencyCode.code === currency.code
                  ? "options__element--selected"
                  : "",
              attrs: { tabindex: "0", role: "menuitem" },
              on: {
                mouseover: function($event) {
                  _vm.isHovering = true;
                },
                mouseout: function($event) {
                  _vm.isHovering = false;
                },
                click: function($event) {
                  return _vm.handleSelect(currency)
                }
              }
            },
            [
              _c("div", { staticClass: "options__text" }, [
                _c(
                  "span",
                  {
                    class:
                      "options__code " +
                      (_vm.selectedCurrencyCode === currency.code
                        ? "options__code--selected"
                        : "")
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(currency.code) + "\n          "
                    ),
                    currency.code === _vm.currencies.hotelCurrency.code
                      ? _c("span", [
                          _vm._v("(" + _vm._s(_vm.labelHotelCurrency) + ")")
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("span", { staticClass: "options__name" }, [
                  _vm._v(_vm._s(currency.name))
                ])
              ]),
              _vm._v(" "),
              _vm.selectedCurrencyCode.code === currency.code
                ? _c("div", { staticClass: "options__text--selected" }, [
                    _c("i", {
                      staticClass: "icon icon-ok-tick-filled xs align-baseline"
                    })
                  ])
                : _vm._e()
            ]
          )
        }),
        _vm._v(" "),
        _vm.filteredCurrencies.length > 1
          ? _c("li", { staticClass: "options__title" }, [
              _vm._v(_vm._s(_vm.labelAllCurrencies))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.filteredCurrencies, function(currency) {
          return _c(
            "li",
            {
              key: currency.code,
              staticClass: "options__element hover",
              class:
                _vm.selectedCurrencyCode.code === currency.code
                  ? "options__element--selected"
                  : "",
              attrs: { tabindex: "0", role: "menuitem" },
              on: {
                mouseover: function($event) {
                  _vm.isHovering = true;
                },
                mouseout: function($event) {
                  _vm.isHovering = false;
                },
                click: function($event) {
                  return _vm.handleSelect(currency)
                }
              }
            },
            [
              _c("div", { staticClass: "options__text" }, [
                _c(
                  "span",
                  {
                    class:
                      "options__code " +
                      (_vm.selectedCurrencyCode === currency.code
                        ? "options__code--selected"
                        : "")
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(currency.code) + "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("span", { staticClass: "options__name" }, [
                  _vm._v(_vm._s(currency.name))
                ])
              ]),
              _vm._v(" "),
              _vm.selectedCurrencyCode.code === currency.code
                ? _c("div", { staticClass: "options__text--selected" }, [
                    _c("i", {
                      staticClass: "icon icon-ok-tick-filled xs align-baseline"
                    })
                  ])
                : _vm._e()
            ]
          )
        })
      ],
      2
    )
  ])
};
var __vue_staticRenderFns__$5 = [];
__vue_render__$5._withStripped = true;

  /* style */
  const __vue_inject_styles__$5 = function (inject) {
    if (!inject) return
    inject("data-v-fcbbb7c0_0", { source: ".options[data-v-fcbbb7c0] {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n@media (min-width: 992px) {\n.options[data-v-fcbbb7c0] {\n    box-shadow: 0 0 23px -8px rgba(0, 0, 0, 0.75);\n}\n}\n.options__content[data-v-fcbbb7c0] {\n  width: 100%;\n  box-shadow: 0 0 20px #ccc;\n}\n.options__input-container[data-v-fcbbb7c0] {\n  height: 4.5rem;\n  padding: 5px;\n  border-bottom: 1px solid #ccc;\n  background-color: white;\n}\n.options__input[data-v-fcbbb7c0] {\n  width: 100%;\n  height: 100%;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  padding-left: 5px;\n}\n@supports (-webkit-touch-callout: none) {\n.options__input[data-v-fcbbb7c0] {\n    font-size: 16px !important;\n}\n}\n.options__list[data-v-fcbbb7c0] {\n  background-color: white;\n  height: 100%;\n  overflow: auto;\n}\n.options__title[data-v-fcbbb7c0] {\n  text-align: left;\n  font-weight: bold;\n  padding: 1rem;\n  font-size: 12px;\n}\n.options__element[data-v-fcbbb7c0] {\n  color: black;\n  display: flex;\n  justify-content: space-between;\n  font-weight: normal;\n  padding: 0.5rem 2rem;\n}\n.options__element--selected[data-v-fcbbb7c0] {\n  background-color: #eeeeee;\n}\n.options__text[data-v-fcbbb7c0] {\n  text-align: left;\n}\n.options__text--selected[data-v-fcbbb7c0] {\n  color: #008800;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.options__code[data-v-fcbbb7c0] {\n  font-size: 14px;\n}\n.options__code--selected[data-v-fcbbb7c0] {\n  font-weight: bold;\n}\n.options__name[data-v-fcbbb7c0] {\n  font-size: 11px;\n}\n.options[data-v-fcbbb7c0]::before {\n  display: none;\n}\n.hover[data-v-fcbbb7c0]:hover {\n  background-color: #f8f8f8;\n}\n\n/*# sourceMappingURL=CurrencyOptions.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-currency-selector/src/components/CurrencyOptions.vue","CurrencyOptions.vue"],"names":[],"mappings":"AAwGA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;ACvGA;ADwGA;AAJA;IAKA,6CAAA;ACrGE;AACF;ADuGA;EACA,WAAA;EACA,yBAAA;ACrGA;ADwGA;EACA,cAAA;EACA,YAAA;EACA,6BAAA;EACA,uBAAA;ACtGA;ADyGA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;ACvGA;ADyGA;AAPA;IAQA,0BAAA;ACtGE;AACF;ADyGA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;ACvGA;AD0GA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;ACxGA;AD2GA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;ACzGA;AD2GA;EACA,yBAAA;ACzGA;AD6GA;EACA,gBAAA;AC3GA;AD6GA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AC3GA;AD+GA;EACA,eAAA;AC7GA;AD8GA;EACA,iBAAA;AC5GA;ADgHA;EACA,eAAA;AC9GA;ADkHA;EACA,aAAA;AC/GA;ADkHA;EACA,yBAAA;AC/GA;;AAEA,8CAA8C","file":"CurrencyOptions.vue","sourcesContent":["<template>\n  <div class=\"options\">\n    <div class=\"options__input-container\">\n      <input autocomplete=\"off\"\n             role=\"menuitem\"\n             type=\"search\"\n             ref=\"search\"\n             :placeholder=\"labelPlaceholder\"\n             class=\"options__input\"\n             :value=\"searchText\"\n             @input=\"filterCurrencies($event.target.value)\"\n             @focus=\"$event.stopPropagation()\"\n             @click=\"$event.stopPropagation()\"\n      />\n    </div>\n    <ul class=\"options__list\" role=\"menu\">\n      <li v-if=\"mainCurrencies.length > 1\" class=\"options__title\">{{ labelMainCurrencies }}</li>\n      <li v-for=\"currency in mainCurrencies\"\n          tabindex=\"0\"\n          class=\"options__element hover\"\n          role=\"menuitem\"\n          :class=\"selectedCurrencyCode.code === currency.code ? 'options__element--selected':''\"\n          @mouseover=\"isHovering = true\"\n          @mouseout=\"isHovering = false\"\n          @click=\"handleSelect(currency)\" :key=\"currency.code\">\n        <div class=\"options__text\">\n          <span :class=\"`options__code ${selectedCurrencyCode === currency.code ? 'options__code--selected' : ''}`\">\n            {{ currency.code }}\n            <span v-if=\"currency.code === currencies.hotelCurrency.code\">({{ labelHotelCurrency }})</span>\n          </span>\n          <br/>\n          <span class=\"options__name\">{{ currency.name }}</span>\n        </div>\n        <div v-if=\"selectedCurrencyCode.code === currency.code\" class=\"options__text--selected\">\n          <i class=\"icon icon-ok-tick-filled xs align-baseline\"></i>\n        </div>\n      </li>\n      <li v-if=\"filteredCurrencies.length > 1\" class=\"options__title\">{{ labelAllCurrencies }}</li>\n      <li v-for=\"currency in filteredCurrencies\"\n          tabindex=\"0\"\n          class=\"options__element hover\"\n          :class=\"selectedCurrencyCode.code === currency.code ? 'options__element--selected' : ''\"\n          @mouseover=\"isHovering = true\"\n          @mouseout=\"isHovering = false\"\n          role=\"menuitem\"\n          @click=\"handleSelect(currency)\" :key=\"currency.code\">\n        <div class=\"options__text\">\n          <span :class=\"`options__code ${selectedCurrencyCode === currency.code ? 'options__code--selected' : ''}`\">\n            {{ currency.code }}\n          </span>\n          <br/>\n          <span class=\"options__name\">{{ currency.name }}</span>\n        </div>\n\n        <div v-if=\"selectedCurrencyCode.code === currency.code\" class=\"options__text--selected\">\n          <i class=\"icon icon-ok-tick-filled xs align-baseline\"></i>\n        </div>\n\n      </li>\n    </ul>\n  </div>\n</template>\n\n<script>\n\nimport Currencies from '@/components/domain/Currencies'\n\nexport default {\n  name: 'CurrencyOptions',\n  props: {\n    currencies: {\n      type: Currencies\n    },\n    selectedCurrencyCode: Object,\n    labelMainCurrencies: String,\n    labelAllCurrencies: String,\n    labelHotelCurrency: String,\n    labelPlaceholder: String\n  },\n  data: () => ({\n    searchText: '',\n    filteredCurrencies: [],\n    mainCurrencies: [],\n    isHovering: false\n  }),\n  created () {\n    this.mainCurrencies = this.currencies.mainCurrencies\n    this.filteredCurrencies = this.currencies.otherCurrencies\n  },\n  methods: {\n    handleSelect (selectedOption) {\n      this.$emit('onSelectOption', selectedOption)\n    },\n    filterCurrencies (text) {\n      this.searchText = text\n      const { mainCurrencies, otherCurrencies } = this.currencies.filterByText(text)\n      this.mainCurrencies = mainCurrencies\n      this.filteredCurrencies = otherCurrencies\n    }\n  }\n}\n</script>\n\n<style lang=\"scss\" scoped>\n.options {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  @media (min-width: 992px) {\n    box-shadow: 0 0 23px -8px rgba(0, 0, 0, 0.75);\n  }\n\n  &__content {\n    width: 100%;\n    box-shadow: 0 0 20px #ccc;\n  }\n\n  &__input-container {\n    height: 4.5rem;\n    padding: 5px;\n    border-bottom: 1px solid #ccc;\n    background-color: white;\n  }\n\n  &__input {\n    width: 100%;\n    height: 100%;\n    border: 1px solid #ccc;\n    border-radius: 3px;\n    padding-left: 5px;\n    // CSS specific to iOS devices\n    @supports (-webkit-touch-callout: none) {\n      font-size: 16px !important;\n    }\n  }\n\n  &__list {\n    background-color: white;\n    height: 100%;\n    overflow: auto;\n  }\n\n  &__title {\n    text-align: left;\n    font-weight: bold;\n    padding: 1rem;\n    font-size: 12px;\n  }\n\n  &__element {\n    color: black;\n    display: flex;\n    justify-content: space-between;\n    font-weight: normal;\n    padding: 0.5rem 2rem;\n\n    &--selected {\n      background-color: #eeeeee;\n    }\n  }\n\n  &__text {\n    text-align: left;\n\n    &--selected {\n      color: #008800;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n    }\n  }\n\n  &__code {\n    font-size: 14px;\n    &--selected {\n      font-weight: bold;\n    }\n  }\n\n  &__name {\n    font-size: 11px;\n  }\n}\n\n.options::before {\n  display: none;\n}\n\n.hover:hover {\n  background-color: #f8f8f8;\n}\n\n</style>\n",".options {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n@media (min-width: 992px) {\n  .options {\n    box-shadow: 0 0 23px -8px rgba(0, 0, 0, 0.75);\n  }\n}\n.options__content {\n  width: 100%;\n  box-shadow: 0 0 20px #ccc;\n}\n.options__input-container {\n  height: 4.5rem;\n  padding: 5px;\n  border-bottom: 1px solid #ccc;\n  background-color: white;\n}\n.options__input {\n  width: 100%;\n  height: 100%;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  padding-left: 5px;\n}\n@supports (-webkit-touch-callout: none) {\n  .options__input {\n    font-size: 16px !important;\n  }\n}\n.options__list {\n  background-color: white;\n  height: 100%;\n  overflow: auto;\n}\n.options__title {\n  text-align: left;\n  font-weight: bold;\n  padding: 1rem;\n  font-size: 12px;\n}\n.options__element {\n  color: black;\n  display: flex;\n  justify-content: space-between;\n  font-weight: normal;\n  padding: 0.5rem 2rem;\n}\n.options__element--selected {\n  background-color: #eeeeee;\n}\n.options__text {\n  text-align: left;\n}\n.options__text--selected {\n  color: #008800;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.options__code {\n  font-size: 14px;\n}\n.options__code--selected {\n  font-weight: bold;\n}\n.options__name {\n  font-size: 11px;\n}\n\n.options::before {\n  display: none;\n}\n\n.hover:hover {\n  background-color: #f8f8f8;\n}\n\n/*# sourceMappingURL=CurrencyOptions.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$5 = "data-v-fcbbb7c0";
  /* module identifier */
  const __vue_module_identifier__$5 = undefined;
  /* functional template */
  const __vue_is_functional_template__$5 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$5 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    false,
    createInjector,
    undefined,
    undefined
  );

//
var script$4 = {
  name: 'Currency',
  components: {
    CurrencyOptions: __vue_component__$5
  },
  props: {
    currencies: Object,
    selectedCurrencyCode: Object,
    labelPrincipal: String,
    labelMainCurrencies: String,
    labelAllCurrencies: String,
    labelHotelCurrency: String,
    labelPlaceholder: String
  },
  data: () => ({
    expanded: false,
    selectedNow: Object
  }),
  created () {
    const self = this;
    document.addEventListener('click', () => {
      self.expanded = false;
    });
    global.$(document).on('keydown', function (e) {
      // ESCAPE key pressed
      if (e.keyCode === 27) {
        self.expanded = false;
      }
    });
  },
  methods: {
    selectOption (selectedCurrency) {
      this.expanded = false;
      this.$emit('onSelectCurrency', selectedCurrency);
    },
    handleToggleOptions: debounce(function () {
      this.expanded = !this.expanded;
    }, 300, {
      leading: true,
      trailing: false
    })
  }
};

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "currency form-group",
      on: {
        click: function($event) {
          return $event.stopPropagation()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "currency__selector",
          on: { click: _vm.handleToggleOptions }
        },
        [
          _c("label", { staticClass: "text-12 font-bold" }, [
            _vm._v(_vm._s(_vm.labelPrincipal))
          ]),
          _vm._v(" "),
          _c("input", {
            staticClass: "form-control read-only-arrow currency__input",
            class: _vm.expanded ? "currency__input--selected" : "",
            attrs: {
              type: "button",
              value: _vm.selectedCurrencyCode.code,
              readonly: "",
              required: ""
            },
            on: {
              focus: _vm.handleToggleOptions,
              click: _vm.handleToggleOptions
            }
          })
        ]
      ),
      _vm._v(" "),
      _vm.expanded
        ? _c(
            "div",
            { staticClass: "currency__options" },
            [
              _c("CurrencyOptions", {
                attrs: {
                  currencies: _vm.currencies,
                  selectedCurrencyCode: _vm.selectedCurrencyCode,
                  labelMainCurrencies: _vm.labelMainCurrencies,
                  labelAllCurrencies: _vm.labelAllCurrencies,
                  labelHotelCurrency: _vm.labelHotelCurrency,
                  labelPlaceholder: _vm.labelPlaceholder
                },
                on: { onSelectOption: _vm.selectOption }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

  /* style */
  const __vue_inject_styles__$4 = function (inject) {
    if (!inject) return
    inject("data-v-7b280abd_0", { source: ".currency[data-v-7b280abd] {\n  margin-bottom: 0;\n}\n.currency__selector[data-v-7b280abd] {\n  max-width: 80px;\n}\n.currency__input[data-v-7b280abd] {\n  border: 1px solid #ccc;\n  border-radius: 0.25rem;\n  font-size: 12px;\n}\n.currency__input--selected[data-v-7b280abd] {\n  border-color: #c20990;\n}\n.currency .read-only-arrow[data-v-7b280abd] {\n  background-position: 90%;\n}\n.currency__option[data-v-7b280abd] {\n  padding: 10px;\n}\n.currency__options[data-v-7b280abd] {\n  margin-top: 1rem;\n  position: absolute;\n  right: 0;\n  z-index: 999;\n  width: 300px;\n  height: 35rem;\n}\n\n/*# sourceMappingURL=Currency.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-currency-selector/src/components/Currency.vue","Currency.vue"],"names":[],"mappings":"AA+EA;EACA,gBAAA;AC9EA;AD+EA;EACA,eAAA;AC7EA;ADgFA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;AC9EA;ADgFA;EACA,qBAAA;AC9EA;ADkFA;EACA,wBAAA;AChFA;ADmFA;EACA,aAAA;ACjFA;ADoFA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;AClFA;;AAEA,uCAAuC","file":"Currency.vue","sourcesContent":["<template>\n  <div class=\"currency form-group\" @click=\"$event.stopPropagation()\">\n\n    <div class=\"currency__selector\" @click=\"handleToggleOptions\">\n      <label class=\"text-12 font-bold\">{{labelPrincipal}}</label>\n      <input\n        type=\"button\"\n        class=\"form-control read-only-arrow currency__input\"\n        :class=\"expanded ? 'currency__input--selected' : ''\"\n        :value=\"selectedCurrencyCode.code\"\n        readonly\n        required\n        @focus=\"handleToggleOptions\"\n        @click=\"handleToggleOptions\"\n      />\n    </div>\n    <div class=\"currency__options\" v-if=\"expanded\">\n      <CurrencyOptions\n        :currencies=\"currencies\"\n        :selectedCurrencyCode=\"selectedCurrencyCode\"\n        :labelMainCurrencies=\"labelMainCurrencies\"\n        :labelAllCurrencies=\"labelAllCurrencies\"\n        :labelHotelCurrency=\"labelHotelCurrency\"\n        :labelPlaceholder=\"labelPlaceholder\"\n        @onSelectOption=\"selectOption\"/>\n    </div>\n  </div>\n\n</template>\n\n<script>\nimport CurrencyOptions from '@/components/CurrencyOptions'\nimport {debounce} from 'lodash'\nexport default {\n  name: 'Currency',\n  components: {\n    CurrencyOptions\n  },\n  props: {\n    currencies: Object,\n    selectedCurrencyCode: Object,\n    labelPrincipal: String,\n    labelMainCurrencies: String,\n    labelAllCurrencies: String,\n    labelHotelCurrency: String,\n    labelPlaceholder: String\n  },\n  data: () => ({\n    expanded: false,\n    selectedNow: Object\n  }),\n  created () {\n    const self = this\n    document.addEventListener('click', () => {\n      self.expanded = false\n    })\n    global.$(document).on('keydown', function (e) {\n      // ESCAPE key pressed\n      if (e.keyCode === 27) {\n        self.expanded = false\n      }\n    })\n  },\n  methods: {\n    selectOption (selectedCurrency) {\n      this.expanded = false\n      this.$emit('onSelectCurrency', selectedCurrency)\n    },\n    handleToggleOptions: debounce(function () {\n      this.expanded = !this.expanded\n    }, 300, {\n      leading: true,\n      trailing: false\n    })\n  }\n}\n</script>\n\n<style lang=\"scss\" scoped>\n.currency {\n  margin-bottom: 0;\n  &__selector {\n    max-width: 80px;\n  }\n\n  &__input {\n    border: 1px solid #ccc;\n    border-radius: .25rem;\n    font-size: 12px;\n\n    &--selected {\n      border-color: #c20990;\n    }\n  }\n\n  .read-only-arrow {\n    background-position: 90%;\n  }\n\n  &__option {\n    padding: 10px\n  }\n\n  &__options {\n    margin-top: 1rem;\n    position: absolute;\n    right: 0;\n    z-index: 999;\n    width: 300px;\n    height: 35rem;\n  }\n}\n</style>\n",".currency {\n  margin-bottom: 0;\n}\n.currency__selector {\n  max-width: 80px;\n}\n.currency__input {\n  border: 1px solid #ccc;\n  border-radius: 0.25rem;\n  font-size: 12px;\n}\n.currency__input--selected {\n  border-color: #c20990;\n}\n.currency .read-only-arrow {\n  background-position: 90%;\n}\n.currency__option {\n  padding: 10px;\n}\n.currency__options {\n  margin-top: 1rem;\n  position: absolute;\n  right: 0;\n  z-index: 999;\n  width: 300px;\n  height: 35rem;\n}\n\n/*# sourceMappingURL=Currency.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$4 = "data-v-7b280abd";
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$4 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    createInjector,
    undefined,
    undefined
  );

class Currency {
  static fromJSON (json) {
    return new Currency({
      code: json.code,
      name: json.name,
      exchangeRate: json.exchangeRate
    })
  }

  constructor ({ code, name, exchangeRate }) {
    this.code = code;
    this.name = name;
    this.exchangeRate = exchangeRate;
  }
}

//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$3 = {
  name: 'CModal',
  data: () => ({
    visible: false,
    height: window.innerHeight
  }),
  watch: {
    visible (value) {
      if (value) {
        this.height = global.innerHeight;
        document.body.style.overflow = 'hidden';
      } else {
        this.height = global.innerHeight;
        document.body.style.overflow = '';
      }
    }
  },
  methods: {
    open () {
      this.visible = true;
      global.flowSingleStep.step1.load({
        closeHandler: () => {
          this.visible = false;
        }
      });
      // window.stackAction('cmodal', () => {
      //   this.visible = false
      // })
    },
    close () {
      this.visible = false;
      global.flowSingleStep.step1.forceBack();
      // window.unstackAction('cmodal')
    }
  }
};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.visible
    ? _c(
        "div",
        {
          class: "c-modal " + (_vm.visible && "c-modal--visible"),
          style: { height: _vm.height + "px" }
        },
        [
          _c("div", { staticClass: "c-modal__header" }, [_vm._t("header")], 2),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-modal__content" },
            [_vm._t("content")],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "c-modal__footer" }, [_vm._t("footer")], 2)
        ]
      )
    : _vm._e()
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = function (inject) {
    if (!inject) return
    inject("data-v-3f3fa0ce_0", { source: ".c-modal[data-v-3f3fa0ce] {\n  display: none;\n  flex-direction: column;\n  width: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  background: white;\n}\n.c-modal--visible[data-v-3f3fa0ce] {\n  display: flex;\n}\n.c-modal__header[data-v-3f3fa0ce] {\n  width: 100%;\n  height: 6rem;\n  border-bottom: solid 1px #dedede;\n}\n.c-modal__content[data-v-3f3fa0ce] {\n  height: calc(100% - 12rem);\n}\n.c-modal__footer[data-v-3f3fa0ce] {\n  width: 100%;\n  height: 6rem;\n}\n\n/*# sourceMappingURL=CModal.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-currency-selector/src/components/modal/CModal.vue","CModal.vue"],"names":[],"mappings":"AAsDA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,iBAAA;ACrDA;ADuDA;EACA,aAAA;ACrDA;ADwDA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;ACtDA;ADyDA;EACA,0BAAA;ACvDA;AD0DA;EACA,WAAA;EACA,YAAA;ACxDA;;AAEA,qCAAqC","file":"CModal.vue","sourcesContent":["<template>\n  <div v-if=\"visible\" :class=\"`c-modal ${visible && 'c-modal--visible'}`\" :style=\"{ height: `${height}px` }\">\n    <div class=\"c-modal__header\">\n      <slot name=\"header\"></slot>\n    </div>\n    <div class=\"c-modal__content\">\n      <slot name=\"content\"></slot>\n    </div>\n    <div class=\"c-modal__footer\">\n      <slot name=\"footer\"></slot>\n    </div>\n  </div>\n</template>\n\n<script>\nexport default {\n  name: 'CModal',\n  data: () => ({\n    visible: false,\n    height: window.innerHeight\n  }),\n  watch: {\n    visible (value) {\n      if (value) {\n        this.height = global.innerHeight\n        document.body.style.overflow = 'hidden'\n      } else {\n        this.height = global.innerHeight\n        document.body.style.overflow = ''\n      }\n    }\n  },\n  methods: {\n    open () {\n      this.visible = true\n      global.flowSingleStep.step1.load({\n        closeHandler: () => {\n          this.visible = false\n        }\n      })\n      // window.stackAction('cmodal', () => {\n      //   this.visible = false\n      // })\n    },\n    close () {\n      this.visible = false\n      global.flowSingleStep.step1.forceBack()\n      // window.unstackAction('cmodal')\n    }\n  }\n}\n</script>\n\n<style lang=\"scss\" scoped>\n  .c-modal {\n    display: none;\n    flex-direction: column;\n    width: 100%;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 999;\n    background: white;\n\n    &--visible {\n      display: flex;\n    }\n\n    &__header {\n      width: 100%;\n      height: 6rem;\n      border-bottom: solid 1px #dedede;\n    }\n\n    &__content {\n      height: calc(100% - 12rem);\n    }\n\n    &__footer {\n      width: 100%;\n      height: 6rem;\n    }\n  }\n</style>\n",".c-modal {\n  display: none;\n  flex-direction: column;\n  width: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  background: white;\n}\n.c-modal--visible {\n  display: flex;\n}\n.c-modal__header {\n  width: 100%;\n  height: 6rem;\n  border-bottom: solid 1px #dedede;\n}\n.c-modal__content {\n  height: calc(100% - 12rem);\n}\n.c-modal__footer {\n  width: 100%;\n  height: 6rem;\n}\n\n/*# sourceMappingURL=CModal.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$3 = "data-v-3f3fa0ce";
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$3 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$2 = {
  name: 'CurrencyModal',
  components: {
    CurrencyOptions: __vue_component__$5,
    CModal: __vue_component__$3
  },
  props: {
    currencies: Object,
    selectedCurrencyCode: Object,
    labelPrincipal: String,
    labelMainCurrencies: String,
    labelAllCurrencies: String,
    labelHotelCurrency: String,
    labelPlaceholder: String
  },
  data: () => ({
    privates: {
      currencies: null
    },
    selectedCurrency: {}
  }),
  mounted() {
  },
  methods: {
    open() {
      this.privates.currencies = this.currencies.clone();
      this.selectedCurrency = this.selectedCurrencyCode;
      showModalOpen(this.$refs.cmodal);
      if (window.navigator.userAgent.includes('Mac') && window.navigator.maxTouchPoints > 2) {
        // eslint-disable-next-line
        $('.entity-hero').css('display', 'none');
        // eslint-disable-next-line
        $('#off-canvas-right').parent().css('display', 'none');
      }
    },
    showSearchBar() {
      if (window.navigator.userAgent.includes('Mac') && window.navigator.maxTouchPoints > 2) {
        // eslint-disable-next-line
        $('.entity-hero').css('display', '');
        // eslint-disable-next-line
        $('#off-canvas-right').parent().css('display', '');
      }
    },
    close() {
      showModalClose$1(this.$refs.cmodal);
      this.showSearchBar();
    },
    selectOption(selectedCurrency) {
      this.selectedCurrency = selectedCurrency;
    },
    onAccept() {
      this.$emit('selectCurrency', this.selectedCurrency);
      showModalClose$1(this.$refs.cmodal);
      this.showSearchBar();
    }
  }
};
const showModalOpen = (modalRef) => {
  modalRef.open();
};
const showModalClose$1 = (modalRef) => {
  modalRef.close();
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("CModal", {
    ref: "cmodal",
    staticClass: "filter-modal",
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c("div", { staticClass: "filter-modal__header" }, [
              _c("div", { staticClass: "filter-modal__secondary-action" }, [
                _vm._v(" ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "filter-modal__title" }, [
                _vm._v(_vm._s(_vm.translate("rdCurrency")))
              ]),
              _vm._v(" "),
              _c("i", {
                staticClass: "icon-close xs icon-right mt-1 text-black-50"
              }),
              _vm._v(" "),
              _c("div", { staticClass: "filter-modal__close" }, [
                _c(
                  "button",
                  {
                    staticClass: "filter-modal__close-button",
                    attrs: { type: "button", tabindex: "0" },
                    on: {
                      click: function($event) {
                        return _vm.close()
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "icon-cross xs icon-right mt-1 text-black-50"
                    })
                  ]
                )
              ])
            ])
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c("CurrencyOptions", {
              attrs: {
                currencies: _vm.privates.currencies,
                selectedCurrencyCode: _vm.selectedCurrency,
                labelPrincipal: _vm.labelPrincipal,
                labelMainCurrencies: _vm.labelMainCurrencies,
                labelAllCurrencies: _vm.labelAllCurrencies,
                labelHotelCurrency: _vm.labelHotelCurrency,
                labelPlaceholder: _vm.labelPlaceholder
              },
              on: { onSelectOption: _vm.selectOption }
            })
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "button",
              {
                staticClass: "filter-modal__accept",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.onAccept()
                  }
                }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.translate("rdCurrencySave")) +
                    "\n    "
                )
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = function (inject) {
    if (!inject) return
    inject("data-v-cfbf8958_0", { source: ".filter-modal__header[data-v-cfbf8958] {\n  display: flex;\n  flex-wrap: nowrap;\n  height: 100%;\n  align-items: center;\n}\n.filter-modal__secondary-action[data-v-cfbf8958] {\n  width: 33%;\n  text-align: left;\n}\n.filter-modal__title[data-v-cfbf8958] {\n  width: 33%;\n  text-align: center;\n  font-size: 16px;\n}\n.filter-modal__close[data-v-cfbf8958] {\n  width: 33%;\n  text-align: right;\n}\n.filter-modal__close-button[data-v-cfbf8958] {\n  border: none;\n  margin-right: 1rem;\n  background-color: transparent;\n}\n.filter-modal__accept[data-v-cfbf8958] {\n  width: 100%;\n  height: 100%;\n  color: white;\n  background: #c00d0d;\n  font-weight: 500;\n  font-size: 14px;\n  border: 0;\n}\n\n/*# sourceMappingURL=CurrencyModal.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-currency-selector/src/components/modal/CurrencyModal.vue","CurrencyModal.vue"],"names":[],"mappings":"AAwGA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;ACvGA;AD0GA;EACA,UAAA;EACA,gBAAA;ACxGA;AD2GA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;ACzGA;AD4GA;EACA,UAAA;EACA,iBAAA;AC1GA;AD6GA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;AC3GA;AD8GA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;AC5GA;;AAEA,4CAA4C","file":"CurrencyModal.vue","sourcesContent":["<template>\n  <CModal class=\"filter-modal\" ref=\"cmodal\">\n    <template v-slot:header>\n      <div class=\"filter-modal__header\">\n        <div class=\"filter-modal__secondary-action\">&nbsp;</div>\n        <div class=\"filter-modal__title\">{{ translate('rdCurrency') }}</div>\n        <i class=\"icon-close xs icon-right mt-1 text-black-50\"/>\n        <div class=\"filter-modal__close\">\n          <button type=\"button\" class=\"filter-modal__close-button\" tabindex=\"0\" @click=\"close()\">\n            <i class=\"icon-cross xs icon-right mt-1 text-black-50\"/>\n          </button>\n        </div>\n      </div>\n    </template>\n    <template v-slot:content>\n      <CurrencyOptions\n          :currencies=\"privates.currencies\"\n          :selectedCurrencyCode=\"selectedCurrency\"\n          :labelPrincipal=\"labelPrincipal\"\n          :labelMainCurrencies=\"labelMainCurrencies\"\n          :labelAllCurrencies=\"labelAllCurrencies\"\n          :labelHotelCurrency=\"labelHotelCurrency\"\n          :labelPlaceholder=\"labelPlaceholder\"\n          @onSelectOption=\"selectOption\"/>\n    </template>\n    <template v-slot:footer>\n      <button type=\"button\" class=\"filter-modal__accept\" @click=\"onAccept()\">\n        {{ translate('rdCurrencySave') }}\n      </button>\n    </template>\n  </CModal>\n</template>\n\n<script>\nimport CModal from '@/components/modal/CModal'\nimport CurrencyOptions from '@/components/CurrencyOptions'\n\nexport default {\n  name: 'CurrencyModal',\n  components: {\n    CurrencyOptions,\n    CModal\n  },\n  props: {\n    currencies: Object,\n    selectedCurrencyCode: Object,\n    labelPrincipal: String,\n    labelMainCurrencies: String,\n    labelAllCurrencies: String,\n    labelHotelCurrency: String,\n    labelPlaceholder: String\n  },\n  data: () => ({\n    privates: {\n      currencies: null\n    },\n    selectedCurrency: {}\n  }),\n  mounted() {\n  },\n  methods: {\n    open() {\n      this.privates.currencies = this.currencies.clone()\n      this.selectedCurrency = this.selectedCurrencyCode\n      showModalOpen(this.$refs.cmodal)\n      if (window.navigator.userAgent.includes('Mac') && window.navigator.maxTouchPoints > 2) {\n        // eslint-disable-next-line\n        $('.entity-hero').css('display', 'none')\n        // eslint-disable-next-line\n        $('#off-canvas-right').parent().css('display', 'none')\n      }\n    },\n    showSearchBar() {\n      if (window.navigator.userAgent.includes('Mac') && window.navigator.maxTouchPoints > 2) {\n        // eslint-disable-next-line\n        $('.entity-hero').css('display', '')\n        // eslint-disable-next-line\n        $('#off-canvas-right').parent().css('display', '')\n      }\n    },\n    close() {\n      showModalClose(this.$refs.cmodal)\n      this.showSearchBar()\n    },\n    selectOption(selectedCurrency) {\n      this.selectedCurrency = selectedCurrency\n    },\n    onAccept() {\n      this.$emit('selectCurrency', this.selectedCurrency)\n      showModalClose(this.$refs.cmodal)\n      this.showSearchBar()\n    }\n  }\n}\nconst showModalOpen = (modalRef) => {\n  modalRef.open()\n}\nconst showModalClose = (modalRef) => {\n  modalRef.close()\n}\n</script>\n\n<style lang=\"scss\" scoped>\n.filter-modal {\n  &__header {\n    display: flex;\n    flex-wrap: nowrap;\n    height: 100%;\n    align-items: center;\n  }\n\n  &__secondary-action {\n    width: 33%;\n    text-align: left;\n  }\n\n  &__title {\n    width: 33%;\n    text-align: center;\n    font-size: 16px;\n  }\n\n  &__close {\n    width: 33%;\n    text-align: right;\n  }\n\n  &__close-button {\n    border: none;\n    margin-right: 1rem;\n    background-color: transparent;\n  }\n\n  &__accept {\n    width: 100%;\n    height: 100%;\n    color: white;\n    background: #c00d0d;\n    font-weight: 500;\n    font-size: 14px;\n    border: 0;\n  }\n}\n</style>\n",".filter-modal__header {\n  display: flex;\n  flex-wrap: nowrap;\n  height: 100%;\n  align-items: center;\n}\n.filter-modal__secondary-action {\n  width: 33%;\n  text-align: left;\n}\n.filter-modal__title {\n  width: 33%;\n  text-align: center;\n  font-size: 16px;\n}\n.filter-modal__close {\n  width: 33%;\n  text-align: right;\n}\n.filter-modal__close-button {\n  border: none;\n  margin-right: 1rem;\n  background-color: transparent;\n}\n.filter-modal__accept {\n  width: 100%;\n  height: 100%;\n  color: white;\n  background: #c00d0d;\n  font-weight: 500;\n  font-size: 14px;\n  border: 0;\n}\n\n/*# sourceMappingURL=CurrencyModal.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$2 = "data-v-cfbf8958";
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$1 = {
  name: 'FixedBar',
  components: {CurrencyModal: __vue_component__$2},
  props: {
    currencies: Object,
    selectedCurrencyCode: Object,
    labelPrincipal: String,
    labelMainCurrencies: String,
    labelAllCurrencies: String,
    labelHotelCurrency: String,
    labelPlaceholder: String
  },
  data: () => ({
    showCurrency: false,
    onModal: false
  }),
  methods: {
    onSelectOption(selectedCurrency) {
      this.$emit('onSelectCurrency', selectedCurrency);
    },
    onCurrencyClick() {
      showModal(this.$refs.currencyModalCommon);
    },
    onCloseCurrency() {
      showModalClose(this.$refs.currencyModalCommon);
    }
  }
};

const showModal = (modalRef) => {
  const scrollTop = window.$('html, body').scrollTop() || 0;
  const offsetTop = window.$('#main').offsetTop || 0;

  if (scrollTop < offsetTop - 1) {
    window.$('html, body').animate({scrollTop: offsetTop}, 500, function () {
      modalRef.open();
    });
  } else {
    modalRef.open();
  }
};

const showModalClose = (modalRef) => {
  modalRef.close();
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "fixed-bar" },
    [
      _c(
        "div",
        {
          staticClass: "fixed-bar__currency",
          on: { click: _vm.onCurrencyClick }
        },
        [
          _c("span", { staticClass: "fixed-bar__selected" }, [
            _vm._v(_vm._s(_vm.selectedCurrencyCode.code))
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.translate("rdCurrency")))])
        ]
      ),
      _vm._v(" "),
      _c("CurrencyModal", {
        ref: "currencyModalCommon",
        attrs: {
          currencies: _vm.currencies,
          selectedCurrencyCode: _vm.selectedCurrencyCode,
          labelPrincipal: _vm.labelPrincipal,
          labelMainCurrencies: _vm.labelMainCurrencies,
          labelAllCurrencies: _vm.labelAllCurrencies,
          labelHotelCurrency: _vm.labelHotelCurrency,
          labelPlaceholder: _vm.labelPlaceholder
        },
        on: {
          selectCurrency: _vm.onSelectOption,
          closeCurrency: _vm.onCloseCurrency
        }
      })
    ],
    1
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = function (inject) {
    if (!inject) return
    inject("data-v-5699bcf0_0", { source: ".fixed-bar[data-v-5699bcf0] {\n  background-color: white;\n  border-radius: 50px;\n  box-shadow: 0px 0px 23px -4px rgba(0, 0, 0, 0.75);\n  position: fixed;\n  z-index: 100;\n  bottom: 0;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  margin-bottom: 2.5rem;\n  text-align: center;\n  width: 30%;\n  left: 37%;\n  font-weight: bold;\n  height: 50px;\n}\n.fixed-bar .line-left[data-v-5699bcf0] {\n  height: 23px;\n}\n.fixed-bar .icon-filters-rd[data-v-5699bcf0] {\n  font-size: 2.3rem;\n}\n.fixed-bar__selected[data-v-5699bcf0] {\n  font-weight: bold;\n}\n.fixed-bar .icon-IDR-rd[data-v-5699bcf0] {\n  font-size: 3rem;\n  margin-bottom: -5px;\n  margin-left: -10px;\n}\n.fixed-bar__filter[data-v-5699bcf0], .fixed-bar__currency[data-v-5699bcf0] {\n  font-size: 12px;\n  padding: 1.5rem 3.5rem 0 !important;\n  cursor: pointer;\n}\n@media (min-width: 991px) {\n.fixed-bar[data-v-5699bcf0] {\n    display: none;\n}\n}\n\n/*# sourceMappingURL=FixedBar.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-currency-selector/src/components/FixedBar.vue","FixedBar.vue"],"names":[],"mappings":"AAyEA;EACA,uBAAA;EACA,mBAAA;EACA,iDAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;ACxEA;AD0EA;EACA,YAAA;ACxEA;AD2EA;EACA,iBAAA;ACzEA;AD4EA;EACA,iBAAA;AC1EA;AD6EA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AC3EA;AD8EA;EAEA,eAAA;EACA,mCAAA;EACA,eAAA;AC7EA;ADgFA;AA1CA;IA2CA,aAAA;AC7EE;AACF;;AAEA,uCAAuC","file":"FixedBar.vue","sourcesContent":["<template>\n  <div class=\"fixed-bar\">\n    <div class=\"fixed-bar__currency\" @click=\"onCurrencyClick\">\n      <span class=\"fixed-bar__selected\">{{ selectedCurrencyCode.code }}</span>\n      <p>{{ translate(\"rdCurrency\") }}</p>\n    </div>\n    <CurrencyModal\n        ref=\"currencyModalCommon\"\n        :currencies=\"currencies\"\n        :selectedCurrencyCode=\"selectedCurrencyCode\"\n        :labelPrincipal=\"labelPrincipal\"\n        :labelMainCurrencies=\"labelMainCurrencies\"\n        :labelAllCurrencies=\"labelAllCurrencies\"\n        :labelHotelCurrency=\"labelHotelCurrency\"\n        :labelPlaceholder=\"labelPlaceholder\"\n        @selectCurrency=\"onSelectOption\"\n        @closeCurrency=\"onCloseCurrency\">\n    </CurrencyModal>\n  </div>\n</template>\n\n<script>\nimport CurrencyModal from '@/components/modal/CurrencyModal'\n\nexport default {\n  name: 'FixedBar',\n  components: {CurrencyModal},\n  props: {\n    currencies: Object,\n    selectedCurrencyCode: Object,\n    labelPrincipal: String,\n    labelMainCurrencies: String,\n    labelAllCurrencies: String,\n    labelHotelCurrency: String,\n    labelPlaceholder: String\n  },\n  data: () => ({\n    showCurrency: false,\n    onModal: false\n  }),\n  methods: {\n    onSelectOption(selectedCurrency) {\n      this.$emit('onSelectCurrency', selectedCurrency)\n    },\n    onCurrencyClick() {\n      showModal(this.$refs.currencyModalCommon)\n    },\n    onCloseCurrency() {\n      showModalClose(this.$refs.currencyModalCommon)\n    }\n  }\n}\n\nconst showModal = (modalRef) => {\n  const scrollTop = window.$('html, body').scrollTop() || 0\n  const offsetTop = window.$('#main').offsetTop || 0\n\n  if (scrollTop < offsetTop - 1) {\n    window.$('html, body').animate({scrollTop: offsetTop}, 500, function () {\n      modalRef.open()\n    })\n  } else {\n    modalRef.open()\n  }\n}\n\nconst showModalClose = (modalRef) => {\n  modalRef.close()\n}\n\n</script>\n\n<style lang=\"scss\" scoped>\n.fixed-bar {\n  background-color: white;\n  border-radius: 50px;\n  box-shadow: 0px 0px 23px -4px rgba(0, 0, 0, 0.75);\n  position: fixed;\n  z-index: 100;\n  bottom: 0;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  margin-bottom: 2.5rem;\n  text-align: center;\n  width: 30%;\n  left: 37%;\n  font-weight: bold;\n  height: 50px;\n\n  .line-left {\n    height: 23px;\n  }\n\n  .icon-filters-rd {\n    font-size: 2.3rem;\n  }\n\n  &__selected {\n    font-weight: bold;\n  }\n\n  .icon-IDR-rd {\n    font-size: 3rem;\n    margin-bottom: -5px;\n    margin-left: -10px;\n  }\n\n  &__filter,\n  &__currency {\n    font-size: 12px;\n    padding: 1.5rem 3.5rem 0 !important;\n    cursor: pointer;\n  }\n\n  @media (min-width: 991px) {\n    display: none;\n  }\n}\n</style>\n",".fixed-bar {\n  background-color: white;\n  border-radius: 50px;\n  box-shadow: 0px 0px 23px -4px rgba(0, 0, 0, 0.75);\n  position: fixed;\n  z-index: 100;\n  bottom: 0;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  margin-bottom: 2.5rem;\n  text-align: center;\n  width: 30%;\n  left: 37%;\n  font-weight: bold;\n  height: 50px;\n}\n.fixed-bar .line-left {\n  height: 23px;\n}\n.fixed-bar .icon-filters-rd {\n  font-size: 2.3rem;\n}\n.fixed-bar__selected {\n  font-weight: bold;\n}\n.fixed-bar .icon-IDR-rd {\n  font-size: 3rem;\n  margin-bottom: -5px;\n  margin-left: -10px;\n}\n.fixed-bar__filter, .fixed-bar__currency {\n  font-size: 12px;\n  padding: 1.5rem 3.5rem 0 !important;\n  cursor: pointer;\n}\n@media (min-width: 991px) {\n  .fixed-bar {\n    display: none;\n  }\n}\n\n/*# sourceMappingURL=FixedBar.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$1 = "data-v-5699bcf0";
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script = {
  name: 'CurrencyContainer',
  components: {
    Currency: __vue_component__$4,
    FixedBar: __vue_component__$1
  },
  props: {
    currenciesList: {
      type: Array,
      required: true
    },
    selectedCurrencyCode: {
      type: Object,
      required: true
    },
    currentCurrency: {
      type: String,
      required: true
    },
    hotelCurrencyCode: {
      type: String,
      required: true
    },
    labelPrincipal: {
      type: String,
      default: 'See prices in'
    },
    labelMainCurrencies: {
      type: String,
      default: 'Main currencies'
    },
    labelAllCurrencies: {
      type: String,
      default: 'All currencies'
    },
    labelHotelCurrency: {
      type: String,
      default: 'Hotel currency'
    },
    labelPlaceholder: {
      type: String,
      default: 'Search your desired currency'
    },
    showMobile: {
      type: Boolean,
      default:false
    }
  },
  data() {
    return {
      currencies: {},
      selectedCurrencyCodeInitial: this.currentCurrency || this.hotelCurrencyCode || ''
    }
  },
  mounted() {
    this.currencies = this.reFormatCurrencies(this.currenciesList);
    this.existsInitialCurrency() || (this.selectedCurrencyCode = { code: this.hotelCurrencyCode });
  },
  computed: {},
  methods: {
    selectCurrency(data) {
      this.$emit('onSelectCurrency', data);
    },
    reFormatCurrencies(data) {
      const mapper = data.map(item => new Currency({
        code: item.currencyCode,
        name: item.currencyName,
        exchangeRate: item.exchangeRate
      }));
      return Currencies.computeCurrencies(
          mapper,
          '' + this.selectedCurrencyCodeInitial,
          '' + this.hotelCurrencyCode)
    },
    existsInitialCurrency() {
      return this.currenciesList.filter((item) => {
        return item.currencyCode === this.selectedCurrencyCode.code
      }).length > 0
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [
    !_vm.showMobile
      ? _c(
          "div",
          { staticClass: "cc-bar__desktop-bar" },
          [
            _c("Currency", {
              attrs: {
                currencies: _vm.currencies,
                selectedCurrencyCode: _vm.selectedCurrencyCode,
                labelPrincipal: _vm.labelPrincipal,
                labelMainCurrencies: _vm.labelMainCurrencies,
                labelAllCurrencies: _vm.labelAllCurrencies,
                labelHotelCurrency: _vm.labelHotelCurrency,
                labelPlaceholder: _vm.labelPlaceholder
              },
              on: { onSelectCurrency: _vm.selectCurrency }
            })
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "cc-bar__mobile-bar" },
          [
            _c("FixedBar", {
              attrs: {
                currencies: _vm.currencies,
                selectedCurrencyCode: _vm.selectedCurrencyCode,
                labelPrincipal: _vm.labelPrincipal,
                labelMainCurrencies: _vm.labelMainCurrencies,
                labelAllCurrencies: _vm.labelAllCurrencies,
                labelHotelCurrency: _vm.labelHotelCurrency,
                labelPlaceholder: _vm.labelPlaceholder
              },
              on: { onSelectCurrency: _vm.selectCurrency }
            })
          ],
          1
        )
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-bf7c8640_0", { source: ".cc-bar__mobile-bar[data-v-bf7c8640] {\n  width: 100%;\n}\n\n/*# sourceMappingURL=CurrencyContainer.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-currency-selector/src/components/CurrencyContainer.vue","CurrencyContainer.vue"],"names":[],"mappings":"AAsHA;EACA,WAAA;ACrHA;;AAEA,gDAAgD","file":"CurrencyContainer.vue","sourcesContent":["<template>\n  <div>\n    <div class=\"cc-bar__desktop-bar\" v-if=\"!showMobile\">\n      <Currency\n          :currencies=\"currencies\"\n          :selectedCurrencyCode=\"selectedCurrencyCode\"\n          :labelPrincipal=\"labelPrincipal\"\n          :labelMainCurrencies=\"labelMainCurrencies\"\n          :labelAllCurrencies=\"labelAllCurrencies\"\n          :labelHotelCurrency=\"labelHotelCurrency\"\n          :labelPlaceholder=\"labelPlaceholder\"\n          @onSelectCurrency=\"selectCurrency\" />\n    </div>\n    <div class=\"cc-bar__mobile-bar\" v-else>\n      <FixedBar\n          :currencies=\"currencies\"\n          :selectedCurrencyCode=\"selectedCurrencyCode\"\n          :labelPrincipal=\"labelPrincipal\"\n          :labelMainCurrencies=\"labelMainCurrencies\"\n          :labelAllCurrencies=\"labelAllCurrencies\"\n          :labelHotelCurrency=\"labelHotelCurrency\"\n          :labelPlaceholder=\"labelPlaceholder\"\n          @onSelectCurrency=\"selectCurrency\" />\n    </div>\n  </div>\n</template>\n\n<script>\nimport Currency from '@/components/Currency.vue'\nimport Currencies from '@/components/domain/Currencies'\nimport CurrencyDomain from '@/components/domain/Currency'\nimport FixedBar from '@/components/FixedBar.vue'\n\nexport default {\n  name: 'CurrencyContainer',\n  components: {\n    Currency,\n    FixedBar\n  },\n  props: {\n    currenciesList: {\n      type: Array,\n      required: true\n    },\n    selectedCurrencyCode: {\n      type: Object,\n      required: true\n    },\n    currentCurrency: {\n      type: String,\n      required: true\n    },\n    hotelCurrencyCode: {\n      type: String,\n      required: true\n    },\n    labelPrincipal: {\n      type: String,\n      default: 'See prices in'\n    },\n    labelMainCurrencies: {\n      type: String,\n      default: 'Main currencies'\n    },\n    labelAllCurrencies: {\n      type: String,\n      default: 'All currencies'\n    },\n    labelHotelCurrency: {\n      type: String,\n      default: 'Hotel currency'\n    },\n    labelPlaceholder: {\n      type: String,\n      default: 'Search your desired currency'\n    },\n    showMobile: {\n      type: Boolean,\n      default:false\n    }\n  },\n  data() {\n    return {\n      currencies: {},\n      selectedCurrencyCodeInitial: this.currentCurrency || this.hotelCurrencyCode || ''\n    }\n  },\n  mounted() {\n    this.currencies = this.reFormatCurrencies(this.currenciesList)\n    this.existsInitialCurrency() || (this.selectedCurrencyCode = { code: this.hotelCurrencyCode })\n  },\n  computed: {},\n  methods: {\n    selectCurrency(data) {\n      this.$emit('onSelectCurrency', data)\n    },\n    reFormatCurrencies(data) {\n      const mapper = data.map(item => new CurrencyDomain({\n        code: item.currencyCode,\n        name: item.currencyName,\n        exchangeRate: item.exchangeRate\n      }))\n      return Currencies.computeCurrencies(\n          mapper,\n          '' + this.selectedCurrencyCodeInitial,\n          '' + this.hotelCurrencyCode)\n    },\n    existsInitialCurrency() {\n      return this.currenciesList.filter((item) => {\n        return item.currencyCode === this.selectedCurrencyCode.code\n      }).length > 0\n    }\n  }\n}\n</script>\n\n<style scoped lang=\"scss\">\n.cc-bar {\n  &__mobile-bar{\n    width: 100%;\n  }\n}\n\n\n</style>\n",".cc-bar__mobile-bar {\n  width: 100%;\n}\n\n/*# sourceMappingURL=CurrencyContainer.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-bf7c8640";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export { __vue_component__ as CurrencyContainer, __vue_component__$2 as CurrencyModalCommon };
